import type { ComputedRef, Ref } from "vue";
import { computed } from "vue";
import type { TodosSubmissionsOverride } from "@/components/MyStudents/Submissions/components/SubmissionsInformation/types";
import { UPLOAD_UNAVAILABLE_TOOLTIP_MESSAGE } from "@/components/MyStudents/Submissions/constants";
import { canTodoAcceptUploads } from "@/components/MyStudents/Submissions/utils";
import { hasMyStudentsToDosEnabled, hasTodoUpdateSubmissionPermission } from "@/composables/authorization.js";

export interface UploadOnBehalfAvailability {
  isVisible: ComputedRef<boolean>;
  isEnabled: ComputedRef<boolean>;
  tooltipMessage: ComputedRef<string | undefined>;
}

export const useUploadOnBehalfAvailability = (
  todoSubmission: Ref<TodosSubmissionsOverride | null | undefined>,
): UploadOnBehalfAvailability => {
  const isVisible = computed<boolean>(() => !!hasMyStudentsToDosEnabled.value);

  const acceptsUploads = computed<boolean>(() => canTodoAcceptUploads(todoSubmission.value));

  const isEnabled = computed<boolean>(
    () => !!hasTodoUpdateSubmissionPermission.value && !todoSubmission.value?.archived_at && acceptsUploads.value,
  );

  const tooltipMessage = computed<string | undefined>(() =>
    acceptsUploads.value ? undefined : UPLOAD_UNAVAILABLE_TOOLTIP_MESSAGE,
  );

  return { isVisible, isEnabled, tooltipMessage };
};
